import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type UseDeleteWatchlistConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useDeleteWatchlist({
  onSuccess,
  onReject,
}: UseDeleteWatchlistConfigs) {
  const { execute: deleteWatchlist, ...query } = useMutation(
    API.deleteWatchlist,
    {
      onSuccess,
      onReject,
    }
  );

  return { deleteWatchlist, ...query };
}
